import React, { useMemo, useState } from "react";
import { Box, Tab, Tabs } from "@mui/material";
import IsMobile from "../../../../hooks/isMobile";
import { IRequest, iEventDetailCMS, iEventType } from "../../../../types/eventTypes";
import { EnumUserCurrentTab, EventSourceEnum } from "../../../../constants/enums";
import B2CDetailsTabContent from "../tabs/B2CDetailsTabContent";
import TransactionDetailsTabContent from "../../transaction-details-tab-content/TransactionDetailsTabContent";
import { getAmountWithCurrency } from "../../../../helpers/common";
import "./b2cEventTabContent.scss";

interface IB2CEventTabContentProps {
	OnClickTriggerLeftContainerScroll?: () => void;
	eventDetail: iEventType;
	selectedType: string;
	request?: IRequest;
	cms: iEventDetailCMS;
}

const B2CEventTabContent: React.FC<IB2CEventTabContentProps> = ({
	eventDetail,
	OnClickTriggerLeftContainerScroll,
	selectedType,
	request,
	cms,
}) => {
	const isMobile = IsMobile();
	const [selectedSubTab, setSelectedSubTab] = useState<EnumUserCurrentTab>(EnumUserCurrentTab.Details);

	const handleSubTabChange = (event: React.SyntheticEvent, newValue: EnumUserCurrentTab) => {
		setSelectedSubTab(newValue);
	};

	const paymentObject = useMemo(() => {
		if (eventDetail?.paymentBalance || eventDetail?.invoices) {
			const paymentBalance = eventDetail?.paymentBalance;
			const amountReceivable = paymentBalance?.amountReceivable;
			const amountPayable = paymentBalance?.amountPayable;
			const paidAmount = paymentBalance?.paymentTotal;
			const actualPaidAmount =
				amountReceivable > 0
					? (paidAmount + amountReceivable)
					: amountPayable > 0
						? (paidAmount - amountPayable)
						: paidAmount;

			return {
				subtotal: paymentBalance?.subTotal ? getAmountWithCurrency(paymentBalance?.subTotal) : "-",
				flatFees: paymentBalance?.shippingFee ? getAmountWithCurrency(paymentBalance?.shippingFee) : "-",
				taxes: paymentBalance?.vatAmount ? getAmountWithCurrency(paymentBalance?.vatAmount) : "-",
				discount: paymentBalance?.discountAmount
					? getAmountWithCurrency(paymentBalance?.discountAmount)
					: "-",
				total: getAmountWithCurrency(
					(paymentBalance?.subTotal || 0) +
						(paymentBalance?.vatAmount || 0) +
						(paymentBalance?.shippingFee || 0) -
						(paymentBalance?.discountAmount || 0),
				),
				invoices: eventDetail.invoices || [],
				// {amountReceivable > 0
				// 	? (paidAmount + amountReceivable).toFixed(2)
				// 	: amountPayable > 0
				// 	? (paidAmount - amountPayable).toFixed(2)
				// 	: paidAmount}
				paidAmount: actualPaidAmount ? getAmountWithCurrency(actualPaidAmount) : "-",
			};
		}
		return {
			subtotal: "-",
			taxes: "-",
			flatFees: "-",
			discount: "-",
			total: "-",
			invoices: [],
			paidAmount: "-",
		};
	}, [eventDetail?.paymentBalance, eventDetail?.invoices]);

	return (
		<Box className="eventTabContentB2C">
			{/* Sub Tabs */}
			<Box className="subTabsContainer">
				<Tabs
					value={selectedSubTab}
					onChange={(event, newValue) => {
						handleSubTabChange(event, newValue);
						OnClickTriggerLeftContainerScroll?.();
					}}
					className="subTabs"
					classes={{
						list: "subTabsFlexContainer",
					}}
					slotProps={{
						indicator: {
							style: {
								display: isMobile ? "block" : "none",
							},
						}
					}}
				>
					<Tab
						label="Details"
						value={EnumUserCurrentTab.Details}
						className={`subTab ${selectedSubTab === EnumUserCurrentTab.Details ? "active" : ""}`}
					/>
					{eventDetail?.source === EventSourceEnum.shopify && eventDetail?.paymentBalance ? (
						<Tab
							label="Payments"
							value={EnumUserCurrentTab.TransactionDetails}
							className={`subTab ${selectedSubTab === EnumUserCurrentTab.TransactionDetails ? "active" : ""}`}
						/>
					) : null}
				</Tabs>
			</Box>

			{/* Sub Tab Content */}
			<Box className="subTabContent">
				{selectedSubTab === EnumUserCurrentTab.Details && (
					<B2CDetailsTabContent
						cms={cms}
						selectedType={selectedType}
						eventDetail={eventDetail}
						request={request}
					/>
				)}
				{selectedSubTab === EnumUserCurrentTab.TransactionDetails && (
					<TransactionDetailsTabContent {...paymentObject} />
				)}
			</Box>
		</Box>
	);
};

export default B2CEventTabContent;
